import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_8: FaireProductEntity = {
  token: "catalog_prod_prod-8",
  type: "product",
  name: "Party Napkins - Confetti Pattern (Set of 20)",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 92.02,
  msrpDollars: 230.05,
  sku: "CO0008",
  caseSize: 4,
  material: "Linen",
  collectionToken: "col_confetti-cake",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 379,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_book-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
